import SortedParticipantsBulletList from './sorted-participants-bullet-list-container'

export default SortedParticipantsBulletList
